<template>
  <div>
    <div class="vx-card p-6">
      <div style="margin-top: 10px; margin-bottom: 20px; font-size: 40px; text-align: center;">
        AKSİYON BEKLEYEN HAREKETLER
      </div>

      <div class="vx-row">
        <!-- ITEMS PER PAGE -->
        <!--   <div class="vx-col" style="margin-right:10px">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2"
                >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
                -
                {{ getMovementList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : getMovementList.length }}
                of {{ getMovementList.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
             <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div> -->

        <!---*************************************************************************-->

        <form class="w-full" @submit.prevent="getMovementList()">
          <div style="width: 100%;">
            <!--1. Row-->
            <div class="vx-row ml-3">
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>İşlem Id</b></label>
                <vs-input size="large" class="w-full" type="number" v-model="searchModel.moduleId" />
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Müşteri Id</b></label>
                <vs-input size="large" class="w-full" type="number" v-model="searchModel.customerId" />
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>İşlem Türü</b></label>
                <v-select @input="getMovementList()" class="w-full" placeholder="Aksiyon Tür" label="name" :options="transactionTypeList" v-model="searchModel.movementType" :reduce="(row) => row.value">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Hesap No</b></label>
                <vs-input class="w-full" type="number" size="large" v-model="searchModel.accountId" />
              </div>
              <div class="vx-col md:w-1/6" v-if="1 == 2">
                <label class="text-sm"><b>Durum</b></label>
                <v-select class="w-full" placeholder="Durum" label="name" :options="statusList" v-model="searchModel.status" :reduce="(row) => row.value">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Hesap Tür</b></label>
                <v-select @input="getMovementList()" class="w-full" placeholder="Hesap Tür" label="name" :options="accountTypeList" v-model="searchModel.accountType" :reduce="(row) => row.value">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Satış Yapan</b></label>
                <v-select @input="getMovementList()" class="w-full" placeholder="Satış Yapan" label="userName" :options="personnalList" v-model="searchModel.createdUserId" :reduce="(row) => row.userId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
            <!--2.row-->
            <div class="vx-row ml-3 mt-3">
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Borç/Alacak</b></label>
                <v-select @input="getMovementList()" class="w-full" placeholder="Borç/Alacak" label="name" :options="debitCreditList" v-model="searchModel.debitCredit" :reduce="(row) => row.value">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Başlangıç</b></label>
                <vs-input class="w-full" type="date" v-model="searchModel.startDate" />
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Bitiş</b></label>
                <vs-input @change="getMovementList()" class="w-full" type="date" v-model="searchModel.finishDate" />
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Muh. Baş.</b></label>
                <vs-input class="w-full" type="date" v-model="searchModel.startTransactionDate" />
              </div>
              <div class="vx-col md:w-1/6">
                <label class="text-sm"><b>Muh. Bit.</b></label>
                <vs-input @change="getMovementList()" class="w-full" type="date" v-model="searchModel.finishTransactionDate" />
              </div>
              <div class="vx-col md:w-1/6">
                <div class="vx-row">
                  <div class="vx-col md:w-1/2">
                    <vs-button style="margin-top: 15px;">Ara</vs-button>
                  </div>
                  <div class="vx-col md:w-1/2">
                    <div style="cursor: pointer; width: 100px; margin-top: 20px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
                      <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
                      <JsonExcel :data="hrManagementList" class>İndir</JsonExcel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <!--***************************************************************************--->
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      </div>
      <vs-divider />
      <!-- prompt for addnew personnel -->

      <!-- AgGrid Table -->

      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        style="height: 60vh;"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="hrManagementList"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :rowClassRules="rowClassRules"
        :context="context"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import CellRendererDetailList from "./CellRenderer/CellRendererDetailList.vue";
import vSelect from "vue-select";
import CellRendererActions from "./CellRenderer/CellRendererActions.vue";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    vSelect,
    CellRendererDetailList,
    CellRendererActions,
    AgGridVue,
    JsonExcel,
  },
  data() {
    return {
      debitCreditList: [
        { name: "Borç", value: "B" },
        { name: "Alacak", value: "A" },
      ],
      accountTypeList: [
        { name: "Müşteri", value: "Customer" },
        { name: "Şirket", value: "Company" },
      ],
      context: null,
      personnalList: [],
      hrManagementList: [],
      transactionTypeList: [
        { name: "Satış", value: "Sale" },
        { name: "Müşteri Ödemesi", value: "CustomerPaymentForOrder" },
        { name: "Müşteri Kapora", value: "CustomerFreePayment" },
        { name: "Müşteri Satış İadesi", value: "ReturnSaleOrder" },
        { name: "Müşteri Tahsilat İadesi", value: "CustomerRepayment" },
        { name: "Satın Alma", value: "Purchase" },
        { name: "Satın Alma Ödemesi", value: "PurchasePayback" },
        { name: "Harcama", value: "Expense" },
        { name: "Uzlaştırma", value: "Reconciliation" },
        { name: "Para Transferi", value: "MoneyTransfer" },
      ],

      searchModel: { movementType: null, finishDate: null, moduleId: null, statusId: null, createUserId: null, customerId: null, status: "B", teamId: this.$store.state.userData.teamId, departmentId: this.$store.state.userData.departmentId },
      statusList: [
        { name: "Bekleyen", value: "B" },
        { name: "Muhabeleşmiş", value: "M" },
      ],
      delayedSearchTimer: "",
      gridApi: null,
      rowClassRules: null,

      gridOptions: { rowHeight: 75, suppressRowTransform: true },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "Fiş Id",
          field: "accountMovementId",
          filter: true,
          width: 50,
        },
        {
          headerName: "GelenId",
          field: "moduleId",
          filter: true,
          width: 50,
        },
        {
          headerName: "Tarih",
          field: "date",
          filter: true,
          width: 50,
        },
        {
          headerName: "Durum",
          field: "statusDescription",
          filter: true,
          width: 100,
        },
        {
          headerName: "Tutar",
          field: "amountStr",
          filter: true,
          width: 50,
        },
        {
          headerName: "Giriş Personel",
          field: "createdUserName",
          filter: true,
          width: 100,
        },
        // {
        //   headerName: "Muhasebe Tarihi",
        //   field: "transactionDate",
        //   filter: true,
        //   width: 50,
        // },

        // {
        //   headerName: "Muhasebe Personel",
        //   field: "transactionUserName",
        //   filter: true,
        //   width: 50,
        // },
        {
          headerName: "Muhasebe Bilgileri",
          cellRendererFramework: "CellRendererDetailList",
          filter: true,
          width: 200,
        },
        {
          headerName: "İşlem",
          field: "transactions",
          width: 50,
          cellRendererFramework: "CellRendererActions",
        },
      ],
    };
  },

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  created() {
    if (this.$route.params != null && this.$route.name == "AccountMovementByModuleId" && this.$route.params.moduleId > 0) {
      this.searchModel.moduleId = this.$route.params.moduleId;
      this.searchModel.accountType = "Customer";
      this.searchModel.status = "B";
    } else if (this.$route.params != null && this.$route.name == "AccountMovementByCustomerId" && this.$route.params.customerId > 0) {
      this.searchModel.customerId = this.$route.params.customerId;
      this.searchModel.accountType = "Customer";
      this.searchModel.status = "B";
    }

    Promise.all([this.getUsers(), this.getMovementList()]);
  },
  methods: {
    getUsers: async function() {
      await repository.getAll("User/getUserList").then((r) => {
        this.personnalList = r.list;
      });

      return this.personnalList;
    },

    getMovementList: async function() {
      this.$vs.loading();
      let list = await repository.postEntity("Accounting/GetAccountMovement", this.searchModel).then((r) => r.list);
      this.$vs.loading.close();
      this.hrManagementList = list;
    },
  },
  beforeMount() {
    this.rowClassRules = {};
    this.context = { componentParent: this };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
};
</script>

<style lang="scss" scoped></style>
